import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import {
  DateAdapter,
  MatNativeDateModule,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatCardModule } from '@angular/material/card';
import { MatTreeModule } from '@angular/material/tree';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MomentUtcDateAdapter } from '../components/moment-utc-date-adapter';
import {
  MatMomentDateModule,
  MAT_MOMENT_DATE_FORMATS,
} from '@angular/material-moment-adapter';

const MATERIAL_MODULES = [
  FormsModule,
  ReactiveFormsModule,
  MatButtonModule,
  MatSelectModule,
  MatInputModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatSidenavModule,
  MatMenuModule,
  MatTableModule,
  MatCheckboxModule,
  MatIconModule,
  MatDatepickerModule,
  MatMomentDateModule,
  MatNativeDateModule,
  MatAutocompleteModule,
  MatDialogModule,
  MatTabsModule,
  MatRadioModule,
  MatSlideToggleModule,
  MatPaginatorModule,
  MatChipsModule,
  NgxMaterialTimepickerModule,
  NgSelectModule,
  MatProgressBarModule,
  MatTooltipModule,
  MatStepperModule,
  MatCardModule,
  MatTreeModule,
  MatSortModule,
];

@NgModule({
  exports: MATERIAL_MODULES,
  imports: MATERIAL_MODULES,
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: [] },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentUtcDateAdapter },
    DatePipe,
  ],
  bootstrap: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AngularMaterialModule {}
